var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { class: _vm.wrapperClassList },
    _vm._l(_vm.items, function (item) {
      return _c("div", { key: item.key, staticClass: "_flexcol" }, [
        _c("span", { staticClass: "_tc--lighter" }, [_vm._v(_vm._s(item.key))]),
        _vm._v(" "),
        _c(
          "span",
          {
            staticClass: "_fw-eb _tc--base",
            attrs: { "data-qa": item.dataQa },
          },
          [_vm._v(_vm._s(item.value))]
        ),
      ])
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }